import TermsAndConditionsNotification from './TermsAndConditionsNotification';

export default TermsAndConditionsNotification;



// WEBPACK FOOTER //
// ./src/client/Components/TermsAndConditionsNotification/index.js